"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function getThemeProps(params) {
  var theme = params.theme,
      name = params.name;

  if (!name || !theme.props || !theme.props[name]) {
    return {};
  }

  return theme.props[name];
}

var _default = getThemeProps;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/styles/getThemeProps.js
// module id = 181
// module chunks = 35783957827783 114276838955818 162898551421021